import { render, staticRenderFns } from "./PermitIpSettingEdit.vue?vue&type=template&id=37a4b583&scoped=true"
import script from "./PermitIpSettingEdit.vue?vue&type=script&lang=js"
export * from "./PermitIpSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./PermitIpSettingEdit.vue?vue&type=style&index=0&id=37a4b583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4b583",
  null
  
)

export default component.exports